import React from 'react';
import Header from '../../components/Layout/Header';
import './Department.css';

const Finance: React.FC = () => {
  return (
    <div className="department-page">
      <Header />
      <div className="department-container">
        <div className="department-header">
          <h1>Finance Department</h1>
          <p className="department-description">
            Welcome to the Finance Department page. Here you can find financial information, 
            budget updates, and accounting resources.
          </p>
        </div>
        <div className="department-content">
          <div className="department-card">
            <h3>About Finance Department</h3>
            <p>
              The Finance Department is responsible for managing the organization's financial resources, 
              accounting, budgeting, financial reporting, and ensuring financial compliance.
            </p>
          </div>
          <div className="department-card">
            <h3>Key Functions</h3>
            <ul>
              <li>Financial Planning and Analysis</li>
              <li>Accounting and Bookkeeping</li>
              <li>Budget Management</li>
              <li>Financial Reporting</li>
              <li>Accounts Payable and Receivable</li>
              <li>Audit and Compliance</li>
            </ul>
          </div>
          <div className="department-card">
            <h3>Contact Information</h3>
            <p>For finance-related inquiries, please contact the Finance Department.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Finance;

